import { createFactory } from 'react';

/**
 * Accepts a function that maps owner props to a new collection of props that are passed to the base component.
 *
 * Implementation has been borrowed from `recompose.js`
 * https://github.com/acdlite/recompose/blob/master/src/packages/recompose/mapProps.js
 *
 * @param propsMapper
 * @returns {function(...[*]=)}
 */
export const mapProps = (propsMapper) => (BaseComponent) => {
  const factory = createFactory(BaseComponent);
  return (props) => factory(propsMapper(props));
};

export default mapProps;
